if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector
}

/*
 Find nearest element that matches the selector
 This code checks to see if the Element.prototype.closest method exists. If it does not exist, it creates a new method
 that takes in a parameter (s) and checks to see if the element matches the parameter. If it does, it returns the element.
 If not, it checks the parent element or parent node until it finds a match or until it reaches a null value. If it
 reaches a null value, it returns null.
*/
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this

        do {
            if (el.matches(s)) return el
            el = el.parentElement || el.parentNode
        } while (el !== null && el.nodeType === 1)
        return null
    }
}
